import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="controller-filter"
export default class extends Controller {
  // Keep dropdown open when clicking on selects
  keepOpen(event) {
    event.stopPropagation()
  }
}
